import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../../actions/alertActions';

// Components - material UI
import { Button } from '@material-ui/core';

// Icons - material UI
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import LockIcon from '@material-ui/icons/Lock';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

// Different Campus Email Extensions list
import { ou_valid_email_extensions } from '../../../utils/valid_email_extensions/ou_valid_email_extensions';
import { smu_valid_email_extensions } from '../../../utils/valid_email_extensions/smu_valid_email_extensions';
import { ut_valid_email_extensions } from '../../../utils/valid_email_extensions/ut_valid_email_extensions';
import { uf_valid_email_extensions } from '../../../utils/valid_email_extensions/uf_valid_email_extensions';
import { ucla_valid_email_extensions } from '../../../utils/valid_email_extensions/ucla_valid_email_extensions';
import { stanford_valid_email_extensions } from '../../../utils/valid_email_extensions/stanford_valid_email_extensions';
import { duke_valid_email_extensions } from '../../../utils/valid_email_extensions/duke_valid_email_extensions';

const School_Email = ({
    school_email,
    onChange,
    auth,
    chat,
    notification,
    getUnreadChats,
    getUnreadCount,
    history,
    goBack,
    nav: {
        campus_ext,
        campus_name
    },
    setAlert
}) => {

    // Screen Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Notification Badge
    const [badgeValue, setBadgeValue] = useState(0);

    const [campus, setCampus] = useState(null);

    const [valid_Extensions, set_Valid_Extensions] = useState(null);

    // Get the current URL and extract the "filter" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const url_campus_id = url.searchParams.get("campus");

    // -- Campus Logic ---

    useEffect(() => {

        if(campus_name) {

            // -- Campus Buy Sell Website --
            if(campus_name.toLowerCase() === 'campus') {
                if(url_campus_id === 'b7nqQGbbbzw08uh0MoPA') { // (OU)  University of Oklahoma
                    set_Valid_Extensions(ou_valid_email_extensions);
                    setCampus('University of Oklahoma (OU)');
                } 
                else if(url_campus_id === 'j4R70faL7jaXTR5Nzeex') { // (UT)  University of Texas
                    set_Valid_Extensions(ut_valid_email_extensions);
                    setCampus('University of Texas (UT)');
                }
                else if(url_campus_id === 'fNie9ly0jB0cs3tZHQaQ') { // (SMU) Southern Methodist University
                    set_Valid_Extensions(smu_valid_email_extensions);
                    setCampus('Southern Methodist University (SMU)');
                }
                else if(url_campus_id === 'g4O5N3JOeQPiMxoSbCex') { // (UF)  Univeristy of Florida
                    set_Valid_Extensions(uf_valid_email_extensions);
                    setCampus('University of Florida (UF)');
                }
                else if(url_campus_id === '3Yeoq4slVvACXGTJLZqo') { // (UCLA) University of California, Los Angeles
                    set_Valid_Extensions(ucla_valid_email_extensions);
                    setCampus('(UCLA) University of California, Los Angeles');
                }
                else if(url_campus_id === 'HujlZDJLvvQGOSIsX1HX') { // Stanford Univeristy (Stanford)
                    set_Valid_Extensions(stanford_valid_email_extensions);
                    setCampus('Stanford University');
                }
                else if(url_campus_id === 'JGYU2vQKslO94zmHoGjM') { // Duke Univeristy (Duke)
                    set_Valid_Extensions(duke_valid_email_extensions);
                    setCampus('Duke University');
                }
            }
            // -- END: Campus Buy Sell Website --
    
            // -- Other Websites --
    
            else if(campus_name.toLowerCase() === 'ou') { // (OU)  University of Oklahoma
    
                set_Valid_Extensions(ou_valid_email_extensions);
                setCampus('University of Oklahoma (OU)');
    
            } else if(campus_name.toLowerCase() === 'smu') { // (SMU) Southern Methodist University
    
                set_Valid_Extensions(smu_valid_email_extensions);
                setCampus('Southern Methodist University (SMU)');
    
            } else if(campus_name.toLowerCase() === 'ut') { // (UT)  University of Texas
                
                set_Valid_Extensions(ut_valid_email_extensions);
                setCampus('University of Texas (UT)');
    
            } else if(campus_name.toLowerCase() === 'uf') { // (UF)  Univeristy of Florida
    
                set_Valid_Extensions(uf_valid_email_extensions);
                setCampus('University of Florida (UF)');

            } else if(campus_name.toLowerCase() === 'ucla') { // (UCLA) University of California, Los Angeles
    
                set_Valid_Extensions(ucla_valid_email_extensions);
                setCampus('(UCLA) University of California, Los Angeles');

            } else if(campus_name.toLowerCase() === 'stanford') { // Stanford Univeristy (Stanford)
    
                set_Valid_Extensions(stanford_valid_email_extensions);
                setCampus('Stanford Univeristy (Stanford)');

            } else if(campus_name.toLowerCase() === 'duke') { // Duke Univeristy (Duke)
    
                set_Valid_Extensions(duke_valid_email_extensions);
                setCampus('Duke Univeristy (Duke)');
                
            }
    
            // -- END: Other Websites --
        }

    }, [campus_name, url_campus_id])

    // --- Campus Logic ---

    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {

        // Fetch unread counts for notifications and chats
        if(auth.user){
            getUnreadCount(auth.user._id);
            getUnreadChats();
        }

    }, [notification.notifications, auth.user]);

    useEffect(() => {

        // Update the badge value to total (Notifications + unread Chats)
        setBadgeValue(notification.num_unread + chat.num_unread_chats);

    }, [notification.num_unread, chat.num_unread_chats])

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    const isSchoolEmail = (string, array_of_campus_exts) => {

        // Join the array of extensions into a single string, separated by '|'
        let extensions = array_of_campus_exts.join('|');

        // Regular expression to match emails with domains ending in any of the provided extensions
        // The dollar sign ($) ensures the match occurs at the end of the string, preventing partial matches
        let regex = new RegExp(`[a-z0-9]+@(${extensions})$`);
    
        // Test if the provided string matches the defined email pattern
        return regex.test(string);
    }

    const school_email_todo = () => {

        if(valid_Extensions?.length > 0) {
            if(school_email.length > 0 && school_email !== auth.user.school_email) {
                if(isSchoolEmail(school_email, valid_Extensions)) {
                    if(url_campus_id) {
                        window.location.href = `/settings/account/verify_school_email?email=${school_email}&campus=${url_campus_id}`;
                    } else {
                        window.location.href = `/settings/account/verify_school_email?email=${school_email}`;
                    }
                } else {
                    setAlert('Enter a valid school email','danger')
                }
                
            } else {
                setAlert('Enter a new school email','danger')
            }
        } else {
            setAlert('Something went wrong','danger')
        }
        
    }

    return (
        <div className="settings">

            {/* Header */}
            <div className="settings__header">

                {/* Back Btn Icon & Badge Value */}
                <div onClick={goBack} className="profile__btnContainer">
                    <ArrowBackIcon />
                    {isMobile && badgeValue > 0 ? (
                        <span className="feed-header-badge defaultBadge">
                            {badgeValue}
                        </span>
                    ) : null}
                </div>

                {/* Title */}
                <div className="settings__headerText">
                    {school_email === '' ? (
                        <h3>
                            Join your campus
                        </h3>
                    ) : (
                        <h3>
                            Change school email
                        </h3>
                    )}
                    
                </div>
            </div>

            {/* Body */}
            <div className="settings__body">

                {campus && (
                    <div style={{width: '100%', boxSizing:'border-box', padding:'10px', display:'flex', justifyContent:'flex-start'}}>

                        {/* Disclaimer text */}
                        <div style={{color: 'rgb(83, 100, 113)', fontSize:'15px', lineHeight: '20px', fontWeight:'500', overflowWrap:'break-word'}}>
                            <span>Enter your official student email to join: </span>
                            <br/>
                            <span style={{color: 'rgb(29, 155, 240)', fontWeight: 'bold'}}>{campus}</span>
                        </div>
                    </div>
                )}

                {/* Input */}
                <div style={{width: '100%', boxSizing:'border-box', padding:'10px', display:'flex', flexDirection: 'column', justifyContent:'center', borderBottom:'1px solid #e6ecf0'}}>
                    <input
                        type="email"
                        placeholder="Enter school email(.edu)"
                        className="input"
                        name="school_email"
                        value={school_email}
                        onChange={e => onChange(e)}
                        // maxlength="30"
                    />

                    <div className='cart_safety_msg'>
                        
                        <VerifiedUserIcon />
                        <span style={{color: '#0a8800', marginLeft: '3px', fontWeight: 500}}>
                            We use your school email to verify you're account.
                        </span>
                    </div>

                    {/* <div className='cart_safety_msg'>
                                        
                        <LockIcon />
                        <span>
                            OU Buy / Sell isn't associated with your school. Your info will never be shared.
                        </span>
                    </div> */}

                </div>

                {/* Submit */}
                <div style={{width: '100%', boxSizing:'border-box', padding:'0 10px', display:'flex', justifyContent:'flex-end'}}>
                    <Button 
                        disabled={school_email === auth.user.school_email}
                        variant="outlined" 
                        className={`sidebar__tweet save ${school_email === auth.user.school_email ? 'disabled' : ''}`}
                        onClick={school_email_todo}
                    >
                        Send PIN
                    </Button>
                </div>
            </div>
        </div>
    )
}

School_Email.propTypes = {
    setAlert: PropTypes.func.isRequired,
    nav: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert
})(School_Email);
